import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import UptimeHeatmap from '~/javascript/components/admin/uptime/UptimeHeatmap.vue'

/**
 * Uptime Heatmap Controller
 *
 * Mounts the Vue UptimeHeatmap component and fetches data from the API.
 */
export default class extends Controller {
  static targets = ['container']

  static values = {
    websiteId: String,
    days: { type: Number, default: 90 }
  }

  connect() {
    console.log('[UptimeHeatmap] Connected for website:', this.websiteIdValue)
    this.mountVueComponent()
  }

  disconnect() {
    if (this.vueApp) {
      this.vueApp.unmount()
      this.vueApp = null
    }
  }

  mountVueComponent() {
    // Mount Vue app
    this.vueApp = createApp(UptimeHeatmap, {
      websiteId: this.websiteIdValue,
      days: this.daysValue,
      apiUrl: `/admin/websites/${this.websiteIdValue}/uptime/heatmap_data`
    })

    // Mount to element or container target
    const mountPoint = this.hasContainerTarget ? this.containerTarget : this.element
    this.vueApp.mount(mountPoint)
  }
}
